import React, { useState } from 'react'
import { Container, Box, Typography, TextField, Button } from '@mui/material'

import { sendContactEnquiry } from '../services/Apis';

const Contactus = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [officeInfo] = useState({
    address: "Indian Book House, 1-8-303/1, 2nd Floor, Near Chikkadpally X Roads, Chikkadpally, Hyderabad, Telangana 500020",
    email: "info@indianbookhouse.com",
    phone: "+91 12345 67890"
  });

  const isEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

 

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone") {
      if (!/^[0-9]*$/.test(value)) return;
      if (value.length > 10) return;
    }
    setForm({ ...form, [name]: value });
    setSuccess("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess("");
    setError("");

    // Validation
    if (
      !form.name||
      !form.email ||
      !form.phone||
      !form.address ||
      !form.message
    ) {
      setError("Please fill all fields.");
      return;
    }
    if (!isEmail(form.email)) {
      setError("Please enter a valid email address.");
      return;
    }
    if (form.phone.length < 10) {
      setError("Phone number must be at least 10 digits.");
      return;
    }
    if (!/^[0-9]{10,20}$/.test(form.phone)) {
      setError("Phone must be numbers only and up to 20 digits.");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        name: form.name,
        email: form.email,
        phoneNumber: form.phone,
        location: form.address,
        message: form.message,
      };
      await sendContactEnquiry(payload);
      setSuccess("Message sent successfully!");
      setForm({
        name: "",
        email: "",
        phone: "",
        address: "",
        message: "",
      });
    } catch (error) {
      setError("Failed to send message. Please try again.");
      console.error("Enquiry API error:", error);
    }
    setLoading(false);
  };

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Typography variant='h5' fontWeight={500} fontSize={'24px'} mb={3}>
        Contact Us
      </Typography>
      <Box
      
        sx={{
          display: { xs: "block", md: "flex" },
          gap: 4,
          alignItems: "flex-start",
        }}
      >
        {/* Office Address */}
        <Box sx={{ flex: "1 1 260px", mb: { xs: 3, md: 0 } }}>
          <Typography variant='h5' fontWeight={500} fontSize={'20px'} mb={2}>
            Office Address
          </Typography>
          <Box sx={{ display: "flex" , gap:2 , alignItems:'center', mb: 2.5 }}>

              <Box
              sx={{
                bgcolor: "#ffefc1",
                borderRadius: "50%",
               padding:2.7,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              
                fontSize: 18,
              }}
            >
              <i className="fas fa-map-marker-alt" style={{ color: "#cb4422", fontSize: '20px' }} />
            </Box>
            <Typography variant='h5' color="#222" sx={{}}>
              {officeInfo.address}
            </Typography>
          </Box>
          <Box sx={{ display: "flex",gap:2, alignItems: "center", mb: 2.5 }}>
            <Box
              sx={{
                bgcolor: "#ffefc1",
                borderRadius: "50%",
                 padding:2.7,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                
                fontSize: 18,
              }}
            >
              <i className="fas fa-envelope" style={{ color: "#cb4422", fontSize: '20px' }} />
            </Box>
            <Typography variant='h5' color="#222">
              {officeInfo.email}
            </Typography>
          </Box>
          <Box sx={{ display: "flex",gap:2, alignItems: "center" }}>
            <Box
              sx={{
                bgcolor: "#ffefc1",
                borderRadius: "50%",
                 padding:2.7,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                
                fontSize: 18,
              }}
            >
              <i className="fas fa-phone" style={{ color: "#cb4422", fontSize: '20px' }} />
            </Box>
            <Typography variant='h5' color="#222">
              {officeInfo.phone}
            </Typography>
          </Box>
        </Box>

        {/* Contact Form */}
        <Box sx={{ flex: "2 1 400px", minWidth: 320 }}>
          <Typography variant='h3' fontWeight={500} mb={2}>
            Drop a Message
          </Typography>
          <Box component="form" onSubmit={handleSubmit}>
            <Box sx={{ display: "flex", gap: 1.5, mb: 1.5, flexDirection: { xs: "column", sm: "row" } }}>
              <TextField
                size="small"
                placeholder="Name"
                name="name"
                value={form.name}
                onChange={handleChange}
                fullWidth
                sx={{ flex: 1, bgcolor: "#f7f7f7", borderRadius: 1 }}
                InputProps={{ style: { fontSize: 14 } }}
                required
              />
              <TextField
                size="small"
                placeholder="Email"
                name="email"
                value={form.email}
                onChange={handleChange}
                fullWidth
                sx={{ flex: 1, bgcolor: "#f7f7f7", borderRadius: 1 }}
                InputProps={{ style: { fontSize: 14 } }}
                required
              />
            </Box>
            <Box sx={{ display: "flex", gap: 1.5, mb: 1.5, flexDirection: { xs: "column", sm: "row" } }}>
              <TextField
                size="small"
                placeholder="Phone"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                fullWidth
                inputProps={{ maxLength: 20 }}
                sx={{ flex: 1, bgcolor: "#f7f7f7", borderRadius: 1 }}
                InputProps={{ style: { fontSize: 14 } }}
                required
              />
              <TextField
                size="small"
                placeholder="Address"
                name="address"
                value={form.address}
                onChange={handleChange}
                fullWidth
                sx={{ flex: 1, bgcolor: "#f7f7f7", borderRadius: 1 }}
                InputProps={{ style: { fontSize: 14 } }}
                required
              />
            </Box>
            <Box sx={{ mb: 1.5 }}>
              <TextField
                placeholder="Message"
                name="message"
                value={form.message}
                onChange={handleChange}
                multiline
                minRows={4}
                fullWidth
                sx={{ bgcolor: "#f7f7f7", borderRadius: 1 }}
                InputProps={{ style: { fontSize: 14 } }}
                required
              />
            </Box>
            {success && (
              <Typography color="success.main" sx={{ mb: 1, textAlign: "center" }}>
                {success}
              </Typography>
            )}
            {error && (
              <Typography color="error.main" sx={{ mb: 1, textAlign: "center" }}>
                {error}
              </Typography>
            )}
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                type="submit"
                variant="contained"
                disabled={loading}
                sx={{
                  bgcolor: "#D44F1C",
                  color: "#fff",
                  borderRadius: 2,
                  px: 3,
                  fontWeight: 500,
                  fontSize: 14,
                  textTransform: "none",
                  "&:hover": { bgcolor: "#b93d13" },
                }}
              >
                {loading ? "Sending..." : "Send Message"}
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Find Us Map */}
      <Box sx={{ mt: 5 }}>
        <Typography variant='h3' fontWeight={500} mb={1}>
          Find Us
        </Typography>
        <Box
          sx={{
            width: "100%",
            minHeight: 150,
            height: 210,
            bgcolor: "#f7f7f7",
            borderRadius: 2,
            border: "1px solid #eee",
            overflow: "hidden",
            position: "relative",
          }}
        >
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3863.327506273185!2d78.5189392052786!3d17.357313164051853!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9953dfdc31d3%3A0x8d4d22ce5043c32a!2sIndian%20Book%20House%20Statlonery!5e0!3m2!1sen!2sin!4v1751266860204!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Map"
          />
        </Box>
      </Box>
    </Container>
  )
}

export default Contactus